import { render } from "./ListeTicket.vue?vue&type=template&id=0b5a8cd6&ts=true"
import script from "./ListeTicket.vue?vue&type=script&lang=ts"
export * from "./ListeTicket.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__